import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {
  HttpClient, HttpRequest,
  HttpEvent,
  HttpEventType, HttpHeaders, HttpParams
} from '@angular/common/http';
import { Http, Response, RequestOptions, ResponseContentType, Headers } from '@angular/http';
import { Apollo } from 'apollo-angular';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as _ from 'lodash';
import { Subject } from "rxjs/Subject";
import * as moment from 'moment';

import { FuseUtils } from '../../../../../core/fuseUtils';

//Local query file
import {
  ScheduleQueryService,
  UserQueryService,
  BookingsQueryService,
  StripeInvoiceQueryService,
  ReportReviewQueryService,
  OcrDumpsQueryService,
  CommonQueryService,
} from '../../queryFiles/index';

/** Servce file */
import { AuthService } from '../../authentication/auth.service';
import { SolutionFormService } from '../solutionForm/solutionForm.service';


/**Local file */
import { apiCalls, orders, spekwo } from '../../utils/index';
import { CommonOrdersService } from './commonOrders.service';

@Injectable()
export class EcommerceOrdersService implements Resolve<any>
{
  apiCalls = apiCalls;
  public orders: any;
  public ownOrders: any;
  userRole: any;
  address: any;
  currentTodo: any;
  routeParams: any;
  allStatus: OrderStatus[];

  ordersValues = orders;
  spekwoValues = spekwo;

  id: any[];
  ordersAttachment: any[];


  public scheduleRequestStatus: any = [];
  public reportReviewStatus: any = [];
  public finalOrdersStatus: any = [];
  public parseStatus: any = [];
  public ocrDocsStatus: any = [];
  public ordersDueDate: any = [];

  searchText: string;
  result: number = 10;

  currentOrderAttachLink: string;
  isOrderHasAttachment: boolean = false;


  onOrdersChanged: BehaviorSubject<any> = new BehaviorSubject({ loading: true, orders: [] });
  onCurrentTodoChanged: BehaviorSubject<any> = new BehaviorSubject([]);
  onSearchTextChanged: Subject<any> = new Subject();
  progressEventObservable: Subject<any> = new Subject();
  youTubeVideos: BehaviorSubject<any> = new BehaviorSubject([]);
  currentOrderPdfFinalLink: BehaviorSubject<any> = new BehaviorSubject({ loading: true, data: '' });
  finalProcessedOrder: BehaviorSubject<any> = new BehaviorSubject({ loading: true, orders: [] });
  onOrderInfoSelected: BehaviorSubject<any> = new BehaviorSubject({ loading: true });

  constructor(
    private http: HttpClient,
    private http1: Http,
    public apollo: Apollo,
    /**Service */
    public authService: AuthService,
    public solutionFormService: SolutionFormService,
    /**Query */
    public scheduleQueryService: ScheduleQueryService,
    public userQueryService: UserQueryService,
    public bookingsQueryService: BookingsQueryService,
    public stripeInvoiceQueryService: StripeInvoiceQueryService,
    public reportReviewQueryService: ReportReviewQueryService,
    public ocrDumpsQueryService: OcrDumpsQueryService,
    public commonQueryService: CommonQueryService,
    public commonOrdersService: CommonOrdersService,
  ) {
    this.commonOrdersService.listOfStatus.subscribe((statusRes) => {
      this.allStatus = statusRes.length > 0 ? statusRes : [];
    });
  }

  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

    this.userRole = window.localStorage.getItem('role');
    this.routeParams = route.params;

    return new Promise((resolve, reject) => {
      Promise.all([
        this.fetchYoutubeVideo(),
        this.authService.GetUserById(),
      ]).then(
        () => {
          if (this.routeParams.todoId) {
            this.setCurrentTodo(this.routeParams.todoId);
          }
          else {
            this.setCurrentTodo(null);
          }

          resolve('');
        },
        reject
      );
    });
  }

  //get attachment of each order
  getAttachmentdata(id): Promise<any> {
    return new Promise((resolve, reject) => {

      this.http.get(this.apiCalls.attachment + '?dev=true&&id=' + id)
        .subscribe((response: any) => {
          // this.ordersAttachment = response;
          // this.getPdfForOldandNewOrder(response);
          resolve(response);
        }, reject);

    });
  }

  async getAttachmentdata1(id, currentOrderId, pdfcheckout): Promise<any> {
    // console.log('getAttachmentdata1');
    return new Promise(async (resolve, reject) => {
      //  Old order - order's attachemnt from backend table
      await this.http.get(this.apiCalls.attachment + '?dev=true&&id=' + id)
        .subscribe(async (response: any) => {

          await this.getPdfForOldandNewOrder(currentOrderId, response, pdfcheckout)
            .then(async data => {
              // console.log('currentOrderPdfFinalLinkfinla', data);
              await this.currentOrderPdfFinalLink.next({ loading: false, data: data });
              resolve(data);
            })
            .catch(() => {
              reject;
            })

        }, reject);

    });
  }


  //Get pdf file for old and new order
  async getPdfForOldandNewOrder(currentOrderId, response, pdfFromCheckout) {

    // console.log('getPdfForOldandNewOrder');

    return new Promise(async (resolve, reject) => {

      if (response !== 'No records found') {

        var currentOrderAttachLink = response.download_link.replace(/['"]+/g, '');
        var isOrderHasAttachment = currentOrderAttachLink.includes("pdf");

        //Check pdf file exist under 'Extra product oprtions'
        if (pdfFromCheckout) {
          this.currentOrderAttachLink = pdfFromCheckout;
          this.isOrderHasAttachment = true;

        } else {

          var docRes = this.solutionFormService.ocrDocumentChange.getValue();

          if (!docRes.loading) {

            var ocrDocumentUrl = docRes.data;
            // its used for production pdf file -will remove afterwards
            if (ocrDocumentUrl && ocrDocumentUrl.message.length > 0) {

              var url = this.apiCalls.ocrDocumentUrl + '/' + currentOrderId + '/' + ocrDocumentUrl.message[0];
              this.currentOrderAttachLink = url;
              this.isOrderHasAttachment = true;

            } else {

              //Old order - From backend table

              this.currentOrderAttachLink = currentOrderAttachLink;
              this.isOrderHasAttachment = isOrderHasAttachment;
            }
          }
        }
        var data = {
          isOrderHasAttachment: this.isOrderHasAttachment,
          currentOrderAttachLink: this.currentOrderAttachLink
        }
        await resolve(data);
      } else {
        var data = {
          isOrderHasAttachment: false,
          currentOrderAttachLink: ''
        }
        await resolve(data);
      }
    })
  }
  //getting all orders from  - Used for Pro person (right now not used)
  getOwnOrders(): Promise<any> {
    this.orders = [];
    this.ownOrders = [];
    var userId;
    return new Promise((resolve, reject) => {
      //Based on Userid get data
      userId = window.localStorage.getItem('userUID');
      this.scheduleQueryService.GET_ALLOCATED_ACCPETED_ORDERS(userId)
        .valueChanges
        .subscribe((response: any) => {

          var responseData = response.data &&
            response.data.allScheduleRequests &&
            response.data.allScheduleRequests.edges;

          if (responseData && responseData.length > 0) {
            var myOrders = [];
            var count = 0;

            //Read all orders one by one
            _.each(responseData, (data) => {
              ++count;
              myOrders.push(data.node);
            })

            if (count == responseData.length) {
              if (myOrders.length > 0) {

                this.ownOrders = myOrders;

                // Get each order details from db
                // Check for bulk query options
                _.each(myOrders, (myData) => {
                  this.getSingleOrder(myData.orderId)
                    .then((result: any) => {
                      if (result.length === myOrders.length) {
                        /**Sort the orders based on id */
                        this.orders = _.reverse(_.sortBy(result, "id"));
                        this.onOrdersChanged.next(_.reverse(_.sortBy(result, "id")));
                        resolve(this.orders);
                      }
                    });
                })
              } else {
                this.orders = [];
                this.ownOrders = [];
                resolve(this.orders);
                this.onOrdersChanged.next(this.orders);
              }

            }
          } else {
            this.orders = [];
            this.ownOrders = [];
            resolve(this.orders);
            this.onOrdersChanged.next(this.orders);
          }
        }, reject);
    });
  }

  getSingleOrder(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.apiCalls.wcOrders + '?dev=true&order_id='
        + id + "&rand=" + Math.round(Math.random() * 999999999))
        .subscribe((response: any) => {

          if (response.status == 'success') {
            var responseResult = JSON.parse(response.message);
            this.orders.length == 0 ? this.orders.push(responseResult) : this.orders = this.orders.concat(responseResult);
            resolve(this.orders);
          } else {
            reject(response);
          }

        }, reject)
    })
  }

  //Compare schedule booking & all orders
  getUnstoredOrders(orders) {
    var temp3 = [];
    return new Promise((resolve, reject) => {
      this.bookingsQueryService.GET_ALL_SCHEDULES()
        .valueChanges
        .subscribe((response: any) => {
          if (response.data.allScheduledBookings.edges.length > 0) {
            temp3 = [];
            var count = 0;
            orders.forEach((allElement) => {
              ++count;
              response.data.allScheduledBookings.edges.filter(element => {
                if (allElement.id == element.node.scheduleBookingId) {
                  temp3.push(allElement);
                }
              });
            })
            if (count === orders.length) {
              resolve(temp3);
            }

          } else {
            resolve(orders);
          }
        }, reject)
    });
  };

  searchOrder() {
    return new Promise((resolve, reject) => {
      if (this.searchText && this.searchText !== '') {
        this.orders = FuseUtils.filterArrayByString(this.orders, this.searchText);
        this.onOrdersChanged.next(this.orders);
        resolve(this.orders);
      }
    })
  }

  /**
  * Set current todo by id
  * @param id
   */

  setCurrentTodo(paramsValue) {
    this.currentTodo = paramsValue;
    console.log('paramsValue', paramsValue);

    this.onCurrentTodoChanged.next([this.currentTodo]);


  }

  /** Fetch video from youtube */
  fetchYoutubeVideo() {

    // var finalURL = this.apiCalls.youtubeApi + this.apiCalls.apiId + "&channelId=" + this.apiCalls.channelId +
    //     "&part=snippet,id&order=date&maxResults=" + this.result;

    // return new Promise((resolve, reject) => {
    //     this.http.get(finalURL + "&random=" + Math.round(Math.random() * 999999999))
    //         .subscribe((response: any) => {
    //             this.youTubeVideos.next(response);
    //             resolve(response)
    //         }, error => {
    //             reject(error);
    //         });
    // })
  }

  /*Upload video to youtube */

  uploadToYoutube(payload, formValue) {

    let formData = new FormData();
    formData.append('video', payload);
    const finalJson = JSON.stringify(formValue);

    return new Promise((resolve, reject) => {
      this.uploadProgress(this.apiCalls.uploadToYoutube + '?formValue=' + finalJson, formData)
        .then((data) => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        })

    })
  }
  uploadProgress(url, formData) {
    return new Promise((resolve, reject) => {

      const uploadReq = new HttpRequest('POST', url, formData, {
        reportProgress: true,
      });

      this.http.request(uploadReq).subscribe((event: HttpEvent<any>) => {

        switch (event.type) {
          case HttpEventType.Sent:
            console.log('Request sent!');
            break;

          case HttpEventType.ResponseHeader:
            console.log('Response header received!');
            break;

          case HttpEventType.UploadProgress:
            const percentage = Math.round(event.loaded / event.total * 100); //For uploading
            this.progressEventObservable.next(percentage);
            break;

          case HttpEventType.Response:
            console.log('Response', Response);
            resolve(event.body);
        }

      }, error => {
        reject(error);
      });

    })
  }



  downloadPDF(commonUrl): any {
    let headers = new Headers();
    headers.append('Content-Type', 'application/pdf');
    headers.append('Accept', 'application/pdf');
    headers.append('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE, PUT');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Credentials', 'true');
    headers.append('Access-Control-Allow-Headers', "X-Requested-With, Content-Type, Origin, Authorization, Accept, Client-Security-Token, Accept-Encoding");
    // let options = new RequestOptions({ headers: headers });
    // sample pdf link https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf
    // // commonUrl = 'http://www.pdf995.com/samples/pdf.pdf';
    return this.http1.get('https://dev.api.spekwo.com/uploads//23176/1420 Rollingwood Inspection.pdf', { responseType: ResponseContentType.Blob, headers: headers })
      .map(
        (res) => {
          return new Blob([res.blob()], { type: 'application/pdf' })
        })
  }

  downalod1() {
    var targetUrl = 'https://dev.api.spekwo.com/uploads//23176/1420 Rollingwood Inspection.pdf';
    this.http.get(targetUrl, { responseType: "blob", headers: { 'Accept': 'application/pdf', 'Access-Control-Allow-Origin': '*' } })
      .subscribe(blob => {
        saveAs(blob, 'download.pdf');
      });
  }

  /*Stripe invoice to customer */

  stripeInvoiceToCustomer(payload) {

    const finalJson = JSON.stringify(payload);
    return new Promise((resolve, reject) => {
      this.http.get(this.apiCalls.stripeInvToCustomer + '?finalJson=' + finalJson)
        .subscribe((response: any) => {

          resolve(response)
        }, error => {
          reject(error);
        });
    })
  }


  storeStripeInvoiceofCustomer(orderId, invoiceObject) {

    return new Promise((resolve, reject) => {

      this.stripeInvoiceQueryService.CREATE_STRIPE_INVOICE_DATA_MUTATION(orderId, invoiceObject)
        .subscribe(() => {
          var object = {
            status: 'success'
          }
          resolve(object)
        }, (err) => {
          reject;
        })


    })

  }

  async GetAllStripeInvoice() {

    return new Promise(async (resolve, reject) => {

      await this.stripeInvoiceQueryService.GET_ALL_STRIPE_INVOICES()
        .valueChanges
        .subscribe(async (stripeInvoice) => {

          if (stripeInvoice &&
            stripeInvoice.data &&
            stripeInvoice.data.allStripeinvoices &&
            stripeInvoice.data.allStripeinvoices.nodes.length > 0) {

            await resolve(stripeInvoice.data.allStripeinvoices.nodes)
          }
          else {
            await resolve([]);
          }

        }, () => {
          reject;
        })

    })
  }

  getInvoiceByOrderId(orderId) {
    return new Promise((resolve, reject) => {
      this.stripeInvoiceQueryService.GET__STRIPE_INVOICES_BY_ID(orderId)
        .valueChanges
        .subscribe(async (stripeInvoice) => {
          if (stripeInvoice &&
            stripeInvoice.data &&
            stripeInvoice.data.allStripeinvoices &&
            stripeInvoice.data.allStripeinvoices.nodes.length > 0) {

            await resolve(stripeInvoice.data.allStripeinvoices.nodes)
          }
          else {
            await resolve([]);
          }

        }, () => {
          reject;
        })

    })
  }
  //to update status oof order
  archiveOrder(nodeId) {

    return new Promise((resolve, reject) => {
      //update the aricve status in db
      this.commonQueryService.UPDATE_ORDER(nodeId, 'trash').subscribe((result: any) => {
        console.log('archiveOrder **', result);
        resolve('success');
      }, error => {
        reject(error);
      });
    });
  }
  //Edit order Table
  editOrder(nodeId, userId, orderDetails, address?, firstName?, agentrole?, clientphone?, clientemail?, indrole?) {
    return new Promise((resolve, reject) => {
      //Edit Order Values in Db
      this.commonQueryService.EDIT_ORDER(nodeId, userId, orderDetails, address, firstName, agentrole, clientphone, clientemail, indrole).subscribe((result: any) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }
  GetAllStripeInvoiceFromPhp() {

    return new Promise((resolve, reject) => {
      this.http.get(this.apiCalls.getAllInvoicesWithCharges)
        .subscribe((response: any) => {
          resolve(response)
        }, error => {
          reject(error);
        });
    })
  }



  /** Get all orders end date from ' Calendar' */
  fetchOrdersDueDate() {


    /* get all schedules*/
    this.bookingsQueryService.GET_ALL_SCHEDULES()
      .valueChanges
      .subscribe((response: any) => {
        this.ordersDueDate = [];
        if (response &&
          response.data &&
          response.data.allScheduledBookings.edges.length > 0) {

          var response = response.data.allScheduledBookings.edges;

          response.forEach((bookings, key) => {

            var data = {
              orderId: bookings && bookings.node.scheduleBookingId,
              orderType: bookings.node.orderType,
              dueDate: (bookings.node.realStart == 'provided' ||
                (bookings.node.realStart == 'end provided')) ? moment(bookings.node.endAt).toDate() : ''
            }

            this.ordersDueDate.push(data);

            if (response.length == this.ordersDueDate.length) {
              /** Get all orders  from ' Report review' */
              this.fetchAllOrderReportReviews();
            }
          })
        }
        else {
          this.fetchAllOrderReportReviews();
        }
      }, () => {
        ;
      })

  }


  /** Get all orders  from ' Report review' */
  fetchAllOrderReportReviews() {

    return new Promise((resolve, reject) => {
      this.reportReviewQueryService.GET_All_REPORTS()
        .subscribe((res: any) => {

          this.reportReviewStatus = [];
          if (res.data &&
            res.data.allReportReviewDetails &&
            res.data.allReportReviewDetails.edges.length > 0) {
            var response = res.data.allReportReviewDetails.edges; //neeed to check single order has multiple entry. should only one

            response.forEach((requests, key) => {

              var data = {
                orderId: requests && requests.node.orderId,
                status: this.allStatus[2].displayStatus
              }

              this.reportReviewStatus.push(data);
            })

          }

          if (res.data.allReportReviewDetails.edges.length == this.reportReviewStatus.length) {
            var result = _.uniqBy(this.reportReviewStatus, 'orderId');
            this.reportReviewStatus = result;
            /**Get all docs of  all orders */
            this.GetAllDocProcess()
              .then(data => {
                resolve(data);

              })
              .catch(err => {
                reject;
              })
          }
        }, err => {
          console.log('GET_ALL_SCHEDULE_REQUESTSerror', err);
        })

    })

  }


  GetAllDocProcess() {

    return new Promise((resolve, reject) => {
      this.ocrDumpsQueryService.CHECK_ALL_DOC_PROCESS()
        .valueChanges
        .subscribe((res: any) => {

          this.ocrDocsStatus = [];

          if (res.data &&
            res.data.allOcrDumps &&
            res.data.allOcrDumps.nodes.length > 0) {
            var response = res.data.allOcrDumps.nodes; //neeed to check single order has multiple entry. should only one

            response.forEach((requests, key) => {

              var data = {
                orderId: requests && requests.node.orderId
              }

              this.ocrDocsStatus.push(data);
            })

          }

          if (res.data.allOcrDumps.nodes.length == this.ocrDocsStatus.length) {
            var result = _.uniqBy(this.ocrDocsStatus, 'orderId');
            this.ocrDocsStatus = result;

            /**Check pdf processed for all orders */
            this.checkDocProcess(this.orders, this.ocrDocsStatus)
              .then(data => {
                console.log('GET_ALL_SCHEDULE_REQUESTSerror', this.ocrDocsStatus);
                resolve(data);
              })
              .catch(err => {
                reject;
              })
          }
        }, err => {
          reject;
          console.log('GET_ALL_SCHEDULE_REQUESTSerror', err);
        })

    })

  }

  /**Check pdf processed for all orders */
  checkDocProcess(orders, ocrDocsStatus) {


    return new Promise((resolve, reject) => {
      var object = {};
      var findResult;
      var findResult1;
      this.parseStatus = [];

      _.each(orders, (data, key) => {

        findResult = _.find(this.reportReviewStatus, { orderId: data.id });
        findResult1 = _.find(this.ocrDocsStatus, { orderId: data.id });

        object = {
          orderId: data.id,
          // If order dump/ report submit means -order is processed
          status: (findResult1 && findResult1 != undefined) ||
            findResult && findResult != undefined ?
            this.allStatus[2].displayStatus :
            this.allStatus[0].displayStatus
        }

        this.parseStatus.push(object);

        if (orders.length == this.parseStatus.length) {
          var result = _.uniqBy(this.parseStatus, 'orderId');
          this.parseStatus = result;
          this.checkStatus(this.parseStatus, this.scheduleRequestStatus)
            .then(data => {
              resolve(data)
            })
            .catch(err => {
              reject;
            })
        }

      })
    })

  }

  /** Combine schduleRequest & OCRDump */
  async checkStatus(parseStatus, scheduleRequestStatus) {

    return new Promise(async (resolve, reject) => {
      this.finalOrdersStatus = [];

      await _.each(parseStatus, (data, index) => {

        var findResult = _.find(scheduleRequestStatus, { orderId: data.orderId });
        var object = {
          [data.orderId]: findResult && findResult != undefined ?
            this.allStatus[findResult.statusId].displayStatus :
            data.status,
          orderId: data.orderId,
          proFirstName: findResult && findResult != undefined ? findResult.proFirstName : '',
          proLastName: findResult && findResult != undefined ? findResult.proLastName : ''
        }

        this.finalOrdersStatus.push(object);

        if (parseStatus.length == this.finalOrdersStatus.length) {

          var result = _.uniqBy(this.finalOrdersStatus, 'orderId');
          this.finalOrdersStatus = result;

          //Finally Assign status
          this.assigOrderStatus()
            .then(data => {
              resolve(data)
            })
            .catch(err => {
              reject;
            })
        }

      })
    })

  }

  //Finally Assign status
  async assigOrderStatus() {

    return new Promise(async (resolve, reject) => {
      var reviewedArray = [], tempArray = [];

      await _.each(this.orders, (data, key) => {
        // Finally get order status
        var findResult = _.find(this.finalOrdersStatus, { orderId: data.id });
        // var findResult1 = _.find(this.ordersDueDate, { orderId: data.id });

        var product = data.line_items && data.line_items.length > 0 ? this.spekwoValues[data.line_items[0].sku] : '';
        var dueDate;

        if (product == this.spekwoValues.HIQFULL) {
          var check = _.find(data.line_items[0].meta_data, { key: "Delivery time" });
          if (check && (check.value).includes("72 hours")) {
            dueDate = moment(new Date(data.date_created)).add(72, 'hours').format('MM/DD/YYYY');
          }

          if (check && (check.value).includes("24 hours")) {
            dueDate = moment(new Date(data.date_created)).add(24, 'hours').format('MM/DD/YYYY');
          }

          if (check && (check.value).includes("48 hours")) {
            dueDate = moment(new Date(data.date_created)).add(48, 'hours').format('MM/DD/YYYY');
          }


        }
        else if ((product == this.spekwoValues.INSPECTIONCALL || product == this.spekwoValues.GCCONSULTING) ||
          product == this.spekwoValues.CGPYWCK || product == this.spekwoValues.RJCZPSJ) {

          var check = _.find(data.meta_data, { key: "myfield2" });

          dueDate = check ? moment(moment(check.value, 'DD/MM/YYYY').toDate()).format('MM/DD/YYYY') : '';
        }

        const target = {
          status: findResult && findResult != undefined ? findResult[data.id] : '-',
          [data.id]: findResult && findResult != undefined ? findResult[data.id] : '-',
          proFirstName: findResult && findResult != undefined ? findResult.proFirstName : '',
          proLastName: findResult && findResult != undefined ? findResult.proLastName : '',
          // dueDate: findResult1 && findResult1 != undefined ? findResult1.dueDate : '',
          dueDate: dueDate ? dueDate : '',
        };
        // Finally assign order status with existing object
        Object.assign(data, target);

        if (this.orders.length == (key + 1)) {
          resolve(this.orders);

        }
      })
    })

  }



  //create status
  createStatus(orderId, statusId, userId) {

    return new Promise((resolve, reject) => {
      this.scheduleQueryService
        .CREATE_STATUS(orderId, statusId, userId)
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    });
  }


  UpdateRequestStatusFromDropDown(nodeId, userRole, statusId) {
    return new Promise((resolve, reject) => {
      this.scheduleQueryService
        .UPDATE_REQUEST_STATUS_FROM_DROP_DOWN(nodeId, userRole, statusId)
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    });
  }
  closeProjectByAdmin(nodeId) {
    return new Promise((resolve, reject) => {
      this.scheduleQueryService
        .UPDATE_PROGRESS_STATUS(nodeId)
        .subscribe((response: any) => {
          resolve(response);
        }, reject)
    });
  }

  async GetOrderBasedStripeInvoice(orderId: number) {

    return new Promise(async (resolve, reject) => {

      await this.stripeInvoiceQueryService.GET_ORDER_BASED_STRIPE_INVOICES(orderId)
        .valueChanges
        .subscribe(async (stripeInvoice) => {

          if (stripeInvoice &&
            stripeInvoice.data &&
            stripeInvoice.data.allStripeinvoices &&
            stripeInvoice.data.allStripeinvoices.nodes.length > 0) {

            await resolve(stripeInvoice.data.allStripeinvoices.nodes)
          }
          else {
            await resolve([]);
          }

        }, () => {
          reject;
        })

    })
  }

  editOrders(nodeId, updatePaylaod) {
    return new Promise((resolve, reject) => {
      //Edit Order Values in Db
      this.commonQueryService.EDIT_ORDERS(nodeId, updatePaylaod).subscribe((result: any) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }

  reportUpload(file, orderId, reportType) {
    let formData = new FormData();
    formData.append('file', file);
    return new Promise((resolve, reject) => {
      const url = this.apiCalls.reportsUpload;
      let params = new HttpParams();
      params = params.append('orderId', orderId);
      params = params.append('reportType', reportType);

      this.http.post(url, formData, { params: params })
        .subscribe(data => {
          console.log("🚀 ~ file: products.service.ts:287 ~ ProductsService ~ returnnewPromise ~ data:", data, reportType)
          resolve(data);
        }, error => {
          reject(error);
        })
    })
  }

  async fetchAllMarkets() {
    return await new Promise(async (resolve, reject) => {
      let markets = [];
      let offset = 0;
      do {
        let payload = {
          offset: offset,
          limit: 10,
        };

        await this.listMarkets(payload).then((marketRes: any) => {
          if (marketRes && marketRes.data && marketRes.data.allMarkets && marketRes.data.allMarkets.nodes && marketRes.data.allMarkets.nodes.length > 0) {
            markets = markets.concat(marketRes.data.allMarkets.nodes);
            offset = offset + 10;
          } else {
            offset = null;
            resolve(markets);
          }
        }).catch((marketsError) => {
          console.log(" await this.listMarkets ~ marketsError:", marketsError)
          reject([]);
        });
      } while (offset != null)
    })
  }

  async formatMarketData(marketData) {
    return await new Promise((resolve, reject) => {
      let temp = [];
      for (let i = 0; i < marketData.length; i++) {
        let tempObj = {
          marketId: marketData[i] && marketData[i].marketId ? marketData[i].marketId : -1,
          marketName: marketData[i] && marketData[i].marketName ? decodeURIComponent(marketData[i].marketName) : null,
        };
        temp.push(tempObj)
      }
      resolve(temp);
    })
  }

  listMarkets(payload) {
    return new Promise(async (resolve, reject) => {
      try {
        await this.commonQueryService.LIST_MARKETS(payload).valueChanges.subscribe((data: any) => {
          resolve(data)
        }, (err) => {
          console.log("lis market err", err)
          reject(err);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  listFirms(payload) {
    return new Promise(async (resolve, reject) => {
      try {
        await this.commonQueryService.LIST_FIRMS(payload).valueChanges.subscribe((data) => {
          resolve(data)
        }, (err) => {
          console.log("lis market err", err)
          reject(err);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  async fetchAllFirms(marketId) {
    return await new Promise(async (resolve, reject) => {
      let firms = [];
      let offset = 0;
      do {
        let payload = {
          offset: offset,
          limit: 10,
          marketId: marketId
        };

        await this.listFirms(payload).then((firmRes: any) => {
          if (firmRes && firmRes.data && firmRes.data.allMarketsMultiFirms && firmRes.data.allMarketsMultiFirms.nodes && firmRes.data.allMarketsMultiFirms.nodes.length > 0) {
            firms = firms.concat(firmRes.data.allMarketsMultiFirms.nodes);
            offset = offset + 10;
          } else {
            offset = null;
            resolve(firms);
          }
        }).catch((firmsError) => {
          console.log(" await this.listfirms ~ firmsError:", firmsError)
          reject([]);
        });
      } while (offset != null)
    })
  }

  async formatFirmsData(firmData) {
    return await new Promise((resolve, reject) => {
      let temp = [];
      for (let i = 0; i < firmData.length; i++) {
        let tempObj = {
          firmId: firmData[i] && firmData[i].firmId ? firmData[i].firmId : -1,
          firmsName: firmData[i] && firmData[i].firmByFirmId.firmsName ? decodeURIComponent(firmData[i].firmByFirmId.firmsName) : null,
          marketName: firmData[i] && firmData[i].marketByMarketId && firmData[i].marketByMarketId.marketName ? decodeURIComponent(firmData[i].marketByMarketId.marketName) : null,
          marketId: firmData[i] && firmData[i].marketId ? firmData[i].marketId : -1,
          marketsMultiFirmsId: firmData[i] && firmData[i].marketsMultiFirmsId ? firmData[i].marketsMultiFirmsId : -1,
        };
        temp.push(tempObj)
      }
      resolve(temp);
    })
  }


  listoffices(payload) {
    return new Promise(async (resolve, reject) => {
      try {
        await this.commonQueryService.LIST_OFFICES(payload).valueChanges.subscribe((data) => {
          resolve(data)
        }, (err) => {
          console.log("lis office err", err)
          reject(err);
        })
      } catch (error) {
        reject(error);
      }
    });
  }

  async fetchallOffices(firmId, marketId) {
    return await new Promise(async (resolve, reject) => {
      let offices = [];
      let offset = 0;
      do {
        let payload = {
          offset: offset,
          limit: 10,
          firmId: firmId,
          marketId: marketId
        };

        await this.listoffices(payload).then((officeRes: any) => {
          if (officeRes && officeRes.data && officeRes.data.allFirmsMultiOffices && officeRes.data.allFirmsMultiOffices.nodes && officeRes.data.allFirmsMultiOffices.nodes.length > 0) {
            offices = offices.concat(officeRes.data.allFirmsMultiOffices.nodes);
            offset = offset + 10;
          } else {
            offset = null;
            resolve(offices);
          }
        }).catch((officesError) => {
          console.log(" await this.listoffices ~ officesError:", officesError)
          reject([]);
        });
      } while (offset != null)
    })
  }

  async formatofficeData(officeData) {
    return await new Promise((resolve, reject) => {
      let temp = [];
      for (let i = 0; i < officeData.length; i++) {
        let tempObj = {
          officeId: officeData[i] && officeData[i].officeId ? officeData[i].officeId : -1,
          officesName: officeData[i] && officeData[i].officeByOfficeId && officeData[i].officeByOfficeId.officesName ? decodeURIComponent(officeData[i].officeByOfficeId.officesName) : null,
          firmId: officeData[i] && officeData[i].firmId ? officeData[i].firmId : -1,
          firmsName: officeData[i] && officeData[i].firmByFirmId && officeData[i].firmByFirmId.firmsName ? decodeURIComponent(officeData[i].firmByFirmId.firmsName) : null,
          firmsMultiOfficesId: officeData[i] && officeData[i].firmsMultiOfficesId ? officeData[i].firmsMultiOfficesId : -1,
        };
        temp.push(tempObj)
      }
      resolve(temp);
    });
  }
}

export interface OrderStatus {
  statusId: number;
  statusName: string;
  displayStatus: string;
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/orders.service.ts